module.exports = __webpack_public_path__ + "img/verdant-laptop.529062e9.jpg";